import { uniq } from 'lodash-es';
import { Inject, Injectable } from '@angular/core';
import {
    Event,
    EventMatchedOffer
} from '../../../../common/models/event.interface';
import { Pid } from '../../../../common/models/pid.interface';
import { Observable } from 'rxjs/Observable';
import { ApiResponse } from '../../../../common/models/api-response.interface';
import { APP_SETTINGS } from '../../app-settings';
import { HttpClient } from '@angular/common/http';
import { EventState } from '../../events/store/event.state';
import { of } from 'rxjs';
import { Account } from '../../../../common/models/account.interface';

@Injectable()
export class PidsService {
    private apiEndpoint;
    constructor(
        private http: HttpClient,
        @Inject(APP_SETTINGS) private appSettings
    ) {
        this.apiEndpoint = appSettings.apiEndpoint;
    }

    public createPidsList(
        events: Event[],
        pidMap: EventState['data']['pids']
    ): number[] {
        const pids: number[] = events.reduce(
            (pids_array: number[], event) =>
                this.getEventPids(event)
                    .concat(this.getEventOfferPids(event.matched_offers))
                    .concat(pids_array),
            []
        );
        return uniq(pids).filter(pid => !pidMap.hasOwnProperty(pid));
    }

    getEventPids(event: Event) {
        return event.pids
            ? event.pids.map(pid_dict => Number(pid_dict.pid))
            : [];
    }

    getEventOfferPids(matched_offers: EventMatchedOffer[]) {
        return matched_offers.reduce(
            (offer_pids: number[], offer) =>
                (offer.attribute && offer.attribute.pids
                    ? (
                          offer.attribute.pids.matchtime_offer_value ||
                          offer.attribute.pids.current_offer_value ||
                          ''
                      )
                          .toString()
                          .split(',')
                          .map(Number)
                    : []
                ).concat(offer_pids),
            []
        );
    }

    public getPidsDetails(pids: number[]): Observable<ApiResponse<Pid[]>> {
        return pids.length > 0
            ? this.http.post<ApiResponse<any>>(`${this.apiEndpoint}pids`, {
                  pids: pids
              })
            : of({ data: [] });
    }

    public searchPids(
        keywords: string,
        partner?: Account
    ): Observable<ApiResponse<Pid[]>> {
        return this.http.get<ApiResponse<Pid[]>>(`${this.apiEndpoint}pids`, {
            params: { keywords: keywords, partner: partner ? partner.id : '' }
        });
    }
}
